import { library } from '@fortawesome/fontawesome-svg-core';
import Buefy from 'buefy';
import __vue_component__ from '../../components/ui/Icon.vue.js';
import { faIcons } from './icons.js';

/**
 * Currently, additional icons only supports icons imported from
 * @fortawesome/sharp-regular-svg-icons (`fasr`).
 */
const initBuefy = (app, additionalIcons = []) => {
    library.add(...faIcons, ...additionalIcons);
    app.component('Icon', __vue_component__);
    app.use(Buefy, {
        defaultIconComponent: 'Icon',
        defaultIconPack: 'fasr',
    });
};

export { initBuefy };
